<script setup lang="ts">
import BirdToRightNoResults from '@/components/svg/birds/BirdToRightNoResults.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps({
  type: {
    type: String,
    default: 'desktop',
    validator: (val: unknown) => typeof val === 'string' && ['desktop', 'mobile'].includes(val),
  },
  isTouchScreen: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div              
    class="no-results text-primary"
    :class="isTouchScreen ? 'mobile' : 'pl-0 xl:pl-5 pr-5'"
  >
    <div class="flex xl:flex-col flex-row">
      <BirdToRightNoResults
        v-if="!isTouchScreen"
        class="bird-no-results block h-auto mb-5 xl:flex hidden"
      />
      <i
        v-if="isTouchScreen"
        class="mi-search-err icon-40 mr-5 xl:hidden flex"
      />
      <div class="flex flex-col">
        <h3 class="mb-3 xl:text-xl text-lg">
          {{ t('no_results_title') }}
        </h3>
        <p class="font-medium xl:text-base text-sm">
          {{ t('no_results_desc_pt1') }}
          <a
            href="https://wa.me/123456789"
            target="_blank"
            rel="noopener"
            class="font-bold"
          >Whatsapp</a>,
          <a
            :href="`mailto:${t('email')}`"
            rel="noopener"
            class="font-bold"
          >{{ t('email_label') }}</a>,
          {{ t('no_results_desc_pt2') }}
          <a
            :href="`tel:${t('support_phone').replace(/\s/g, '')}`"
            rel="noopener"
            class="font-bold"
          >{{ t('support_phone') }}</a>
        </p>
      </div>
    </div>
    <hr
      v-if="type === 'mobile'"
      class="mt-0 mb-2 border-primary opacity-50 w-100"
    >
  </div>
</template>

<i18n>
  {
    "cs": {
    "email": "info{'@'}mixit.cz",
    "email_label": "E-mail",
    "no_results_desc_pt1": "Potřebujete s něčím pomoci? Napište nám na",
    "no_results_desc_pt2": "nebo nám můžete zavolat na",
    "no_results_title": "Bohužel jsme nenašli zobání, které hledáte 😕",
    "support_phone": "+420 725 366 466",
    "whatsapp": "https://wa.me/420725366466"
},
    "sk": {
    "email": "info{'@'}mixit.sk",
    "email_label": "E-mail",
    "no_results_desc_pt1": "Potrebujete s niečím pomôcť? Napíšte nám na",
    "no_results_desc_pt2": "alebo nám môžete zavolať na",
    "no_results_title": "Bohužiaľ, nemohli sme nájsť snack, ktorý hľadáte 😕",
    "support_phone": "+420 725 366 466",
    "whatsapp": "https://wa.me/420725366466"
},
    "pl": {
    "email": "biuro{'@'}mixit.pl",
    "email_label": "Adres e-mail",
    "no_results_desc_pt1": "Potrzebujesz pomocy? Napisz do nas na adres",
    "no_results_desc_pt2": "lub zadzwoń do nas pod numer",
    "no_results_title": "Niestety nie znaleźliśmy produktu, którego szukasz 😕",
    "support_phone": "(+48) 22 300 17 88",
    "whatsapp": ""
},
    "hu": {
    "email": "info{'@'}mixit.cz",
    "email_label": "E-mail",
    "no_results_desc_pt1": "Segítségre van szüksége? Írjon nekünk a",
    "no_results_desc_pt2": "vagy hívhat minket a",
    "no_results_title": "Sajnos nem találtuk meg a keresett csemegét 😕",
    "support_phone": "+420 725 366 466",
    "whatsapp": "https://wa.me/420725366466"
},
    "de": {
    "email": "Info{'@'}mixit.de",
    "email_label": "E-Mail",
    "no_results_desc_pt1": "Benötigst du Unterstützung? Schreib uns",
    "no_results_desc_pt2": "oder rufe uns an unter",
    "no_results_title": "Leider haben wir das von dir gesuchte Produkt nicht gefunden 😕",
    "support_phone": "+49 221 846 151 11",
    "whatsapp": ""
},
    "at": {
    "email": "Info{'@'}mixit.de",
    "email_label": "E-Mail",
    "no_results_desc_pt1": "Benötigst du Unterstützung? Schreib uns",
    "no_results_desc_pt2": "oder rufe uns an unter",
    "no_results_title": "Leider haben wir das von dir gesuchte Produkt nicht gefunden 😕",
    "support_phone": "+49 221 846 151 11",
    "whatsapp": ""
},
    "ro": {
    "email": "info{'@'}mixit.ro",
    "email_label": "E-mail",
    "no_results_desc_pt1": "Ai nevoie de ajutor? Scrie-ne la",
    "no_results_desc_pt2": "sau ne puteți suna la",
    "no_results_title": "Ne pare rău, nu am găsit bunătatea pe care o cauți 😕",
    "support_phone": "+40 373 761 377",
    "whatsapp": ""
}
  }
</i18n>

<style lang="scss" scoped>
.bird-no-results {
    width: 100%;
    max-width: 200px;
    height: auto;
}

.no-results {
    width: 430px;

    &.mobile {
        width: 100%;
    }
}
@media screen and (max-width: 1340px) {
    .no-results {width: 200px;}
}
</style>